export default __webpack_public_path__ + "static/hq3-40984ce2db4c5043e7e1725297349e2e.jpg";